import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { conciergeApi, TOKEN_KEY, errMsg } from "@/components/concierge/api";

export default function ConciergeLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await conciergeApi.post("/login", { username, password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      navigate("/etoile/espace");
    } catch (error) {
      toast.error(errMsg(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-pink-900 flex items-center justify-center p-4" data-testid="concierge-login-page">
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm space-y-4">
        <div className="text-center">
          <img src="https://customer-assets-rejwkqb3.emergentagent.net/job_2865d04f-1753-4ac2-b4d4-74d332d7faa7/artifacts/d20c424927cac4c3_t%C3%A9l%C3%A9chargement.jpg" alt="Formation Pressing Sakura & L'Étoile Part-Dieu" className="w-56 mx-auto mb-2" data-testid="concierge-login-logo" />
          <h1 className="text-2xl font-bold">Espace Conciergerie</h1>
          <p className="text-sm text-slate-500">L'Étoile Part-Dieu × Pressing Sakura</p>
        </div>
        <Input placeholder="Identifiant" value={username} onChange={(e) => setUsername(e.target.value)} required data-testid="concierge-username" />
        <Input type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="concierge-password" />
        <Button type="submit" className="w-full h-12 bg-pink-600 hover:bg-pink-700" disabled={loading} data-testid="concierge-login-btn">
          <Lock className="w-4 h-4 mr-2" />{loading ? "Connexion..." : "Se connecter"}
        </Button>
      </form>
    </div>
  );
}
